var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.236564 16.6027L7.15293 9.57535C7.30462 9.42202 7.3897 9.21504 7.3897 8.99936C7.3897 8.78367 7.30462 8.5767 7.15293 8.42337L0.238064 1.396C0.0864532 1.24172 0.00150013 1.03407 0.00150013 0.817762C0.00150013 0.601457 0.0864532 0.393803 0.238064 0.239523C0.312128 0.163552 0.400651 0.103175 0.498414 0.0619507C0.596177 0.0207259 0.701204 -0.000513077 0.807303 -0.000513077C0.913403 -0.000513077 1.01843 0.0207259 1.11619 0.0619507C1.21396 0.103175 1.30248 0.163552 1.37654 0.239523L8.29141 7.26539C8.74579 7.72817 9.00037 8.3508 9.00037 8.99936C9.00037 9.64791 8.74579 10.2706 8.29141 10.7333L1.37654 17.7592C1.30245 17.8354 1.21384 17.896 1.11594 17.9373C1.01804 17.9787 0.912834 18 0.806553 18C0.700272 18 0.595072 17.9787 0.497169 17.9373C0.399267 17.896 0.310651 17.8354 0.236564 17.7592C0.084953 17.6049 0 17.3973 0 17.181C0 16.9646 0.084953 16.757 0.236564 16.6027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.ed69de9d8ec0c1bda28c9714362ee36e.svg";
export { ForwardRef as ReactComponent };